import React, { useState, useEffect } from 'react';
import axios from 'axios';
import countries from './country/country';
import { Link } from 'react-router-dom';

const ResultatRech = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const savedFormations = JSON.parse(localStorage.getItem('formations')) || [];
  const savedParams = JSON.parse(localStorage.getItem('searchParams')) || {};
  const savedHasSearched = localStorage.getItem('hasSearched') === 'true';

  const [searchData, setSearchData] = useState(savedFormations);
  const [hasSearched, setHasSearched] = useState(savedHasSearched);

  const [selectedCountry, setSelectedCountry] = useState(
    savedParams.pays || '',
  );
  const [domaines, setDomaines] = useState([]);
  const [selectedDomaine, setSelectedDomaine] = useState(
    savedParams.domaine || '',
  );
  const [formations, setFormations] = useState([]);
  const [selectedFormationNom, setSelectedFormationNom] = useState(
    savedParams.formationNom || '',
  );
  const [selectedType, setSelectedType] = useState(savedParams.type || '');
  const [selectedDate, setSelectedDate] = useState(savedParams.date || '');
  const [marches, setMarches] = useState(['Marché A', 'Marché B', 'Marché C']); // exemple
  const [selectedMarche, setSelectedMarche] = useState(
    savedParams.marche || '',
  );

  const Url = process.env.REACT_APP_URL_DEV;
  const domainesApiURL = `${Url}/api/Domaine/all`;
  const formationsApiURL = `${Url}/api/formation/formations/domaine`;

  const calculerDuree = (dateDebut, dateFin) => {
    if (!dateDebut || !dateFin) return 'Durée inconnue';
    const debut = new Date(dateDebut);
    const fin = new Date(dateFin);
    if (isNaN(debut.getTime()) || isNaN(fin.getTime()))
      return 'Dates invalides';
    const difference = Math.ceil((fin - debut) / (1000 * 60 * 60 * 24));
    return difference > 0 ? `${difference} jours` : 'Dates incohérentes';
  };

  // 🔹 Fonction centralisée pour la recherche
  const fetchSearchResults = async () => {
    const data = {
      domaine: selectedDomaine,
      formationNom: selectedFormationNom || '',
      date: selectedDate,
      pays: selectedCountry,
      type: selectedType,
      marche: selectedMarche,
    };

    try {
      const response = await axios.post(`${Url}/api/Formation/recherche`, data);
      setSearchData(response.data.data || []);
      localStorage.setItem(
        'formations',
        JSON.stringify(response.data.data || []),
      );
      localStorage.setItem('searchParams', JSON.stringify(data));
      setHasSearched(true);
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      setSearchData([]);
      localStorage.setItem('formations', JSON.stringify([]));
      localStorage.setItem('searchParams', JSON.stringify(data));
      setHasSearched(true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchSearchResults();
  };

  // 🔹 Récupérer les domaines
  useEffect(() => {
    const fetchDomaines = async () => {
      try {
        const response = await axios.get(domainesApiURL);
        const data = response.data.data;
        if (Array.isArray(data)) setDomaines(data);
      } catch (error) {
        console.error('Erreur lors de la récupération des domaines :', error);
      }
    };
    fetchDomaines();
  }, [domainesApiURL]);

  // 🔹 Récupérer les formations selon le domaine sélectionné
  useEffect(() => {
    if (selectedDomaine) {
      const fetchSousDomaines = async () => {
        try {
          const response = await axios.get(
            `${formationsApiURL}/${selectedDomaine}`,
          );
          const data = response.data.data;
          if (Array.isArray(data)) setFormations(data);
          else setFormations([]);
        } catch (error) {
          setFormations([]);
        }
      };
      fetchSousDomaines();
    } else {
      setFormations([]);
    }
  }, [selectedDomaine, formationsApiURL]);

  // 🔹 Déclencher la recherche automatiquement à chaque changement de filtre
  useEffect(() => {
    if (
      selectedDomaine ||
      selectedFormationNom ||
      selectedType ||
      selectedDate ||
      selectedCountry ||
      selectedMarche
    ) {
      fetchSearchResults();
    }
  }, [
    selectedDomaine,
    selectedFormationNom,
    selectedType,
    selectedDate,
    selectedCountry,
    selectedMarche,
  ]);

  // 🔹 Filtrer résultats par type, marché et formation
  const filteredResults = searchData.filter((result) => {
    if (selectedType) {
      if (!result.formationType) return false;
      const typesArray = result.formationType
        .split(',')
        .map((t) => t.trim().toLowerCase());
      if (!typesArray.includes(selectedType.trim().toLowerCase())) return false;
    }
    if (selectedMarche) {
      if (!result.marche) return false;
      if (result.marche !== selectedMarche) return false;
    }
    if (selectedFormationNom) {
      if (!result.formation) return false;
      if (result.formation !== selectedFormationNom) return false;
    }
    return true;
  });

  return (
    <div className="container55">
      <div className="sidebar2">
        <h3 className="mg-top-1">Affiner la recherche</h3>
        <div className="filter-section">
          <select
            name="domaine"
            value={selectedDomaine}
            onChange={(e) => setSelectedDomaine(e.target.value)}
          >
            <option value="">Choisissez un domaine</option>
            {domaines.map((domaine) => (
              <option key={domaine.domaineId} value={domaine.domaineId}>
                {domaine.domaineNom}
              </option>
            ))}
          </select>

          <select
            name="formation"
            value={selectedFormationNom}
            onChange={(e) => setSelectedFormationNom(e.target.value)}
          >
            <option value="">Formation associée</option>
            {formations.map((formation) => (
              <option
                key={formation.formationCode}
                value={formation.formationNom}
              >
                {formation.formationNom}
              </option>
            ))}
          </select>

          <select
            name="type"
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
          >
            <option value="">Type de formation</option>
            <option value="Présentiel">Présentiel</option>
            <option value="En ligne">En ligne</option>
          </select>

          <h6>Date de la formation à partir de</h6>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />

          <h6>Pays de la formation</h6>
          <select
            name="pays"
            value={selectedCountry}
            onChange={(e) => setSelectedCountry(e.target.value)}
          >
            <option value="">Choisissez un pays</option>
            {countries.map((country, index) => (
              <option key={index} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>

        <button
          className="btn-clear-filters mt-3"
          type="button"
          onClick={handleSubmit}
        >
          RECHERCHE
        </button>
      </div>

      <div className="result-container">
        <div className="result-count mg-top-1">
          <span className="count">{filteredResults.length}</span> RÉSULTATS
        </div>
        <h2>Formations</h2>
        <div className="results-list">
          {filteredResults.length > 0 ? (
            filteredResults.map((result, index) => (
              <div key={index} className="result-card">
                <div className="card-header">
                  <h3>{result.domaine}</h3>
                  <p>{result.formation}</p>
                </div>
                <div className="card-footer">
                  <span className="duration">
                    ⏱ {calculerDuree(result.dateDebut, result.dateFin)}
                  </span>
                  <span className="location">
                    📍 {result.pays || 'Non spécifié'}
                  </span>
                  <div className="flex flex-wrap gap-2">
                    {result.formationType?.split(',').map((type, idx) => (
                      <span
                        key={idx}
                        className="bg-gray-200 text-gray-800 px-2 py-1 rounded flex items-center gap-1 text-sm"
                      >
                        {type.trim() === 'En ligne' && <>🌐 En ligne</>}
                        {type.trim() === 'Présentiel' && <>🏫 Présentiel</>}
                        {type.trim() === 'E-learning' && <>💻 E-learning</>}
                      </span>
                    ))}
                  </div>
                  <Link
                    className="information"
                    to={{
                      pathname: `/CourseDetails2/${result.formationCode}`,
                      state: { formation: result },
                    }}
                  >
                    Plus d’informations
                  </Link>
                  <p>
                    📅 Date Début :{' '}
                    {new Date(result.dateDebut).toLocaleDateString('fr-FR')} |
                    📅 Date Fin :{' '}
                    {new Date(result.dateFin).toLocaleDateString('fr-FR')}
                  </p>
                </div>
              </div>
            ))
          ) : hasSearched ? (
            <p>Aucune formation trouvée pour le moment.</p>
          ) : (
            <p>Veuillez affiner votre recherche.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResultatRech;
